import { createThunk } from '@app/store/thunk'

type IconContextInterface = {
  useIcon: (size: string, name: string) => string | null
}

export function getIconContext() {
  return createThunk((_dispatch, _getState, context) => context.lookupEnsure<IconContextInterface>(IconSymbol))
}

export function setIconContext(value: IconContextInterface) {
  return createThunk((_dispatch, _getState, context) => context.getRootContext().set(IconSymbol, value))
}

const IconSymbol = Symbol('IconContext')
